import AccettazioneSsn from "../";

const routes = [
    { name: "Elenco Accettazione Ssn", path: "/accettazionessn", component: AccettazioneSsn.AccettazioneSsnListPage, meta: { title: "Elenco Accettazione Ssn" } },
    { name: "Accettazione Ssn", path: "/accettazionessn/:id", component: AccettazioneSsn.AccettazioneSsnEditViewPage, meta: { title: "Edit Accettazione Ssn" } }
];

export default routes;
